export default {
  methods: {
    $_getCommentByType(messageObject) {
      return new Promise((resolve) => {
        let result = ''
        if (messageObject.message.Comment) {
          resolve(messageObject.message.Comment)
        }
        const secondLineStule = 'style="margin-top: 5px;"'
        let statusFromText = ''
        let statusToText = ''
        let newStatus = ''
        /*const firstLine = `<div>${this.$t('Notifications.NotificationToTender', {
          tenderNumber: messageObject.entity.Number,
          tenderTitle: messageObject.entity.Title
        })}</div>` */
        switch (messageObject.message.messageType) {
        case 'ChangeTenderAgreeStatus':
          newStatus = 'Відхилено'
          if (messageObject.message.properties.find(i => i.key === 'AgreementStatus')?.value === 'Success') {
            newStatus = 'Узгоджено'
          }
          result += `<div ${secondLineStule}>${this.$t('Notifications.NotificationType.ChangeTenderAgreeStatus')}</div>
          <div>${this.$t('Common.Status')}: ${this.$t(newStatus)}</div>`
          break
        case 'ChangeTenderStatus':
          if (messageObject.message.StatusFrom) { statusFromText = this.$store.getters.getTenderAllStatuses.find(i => i.statusCode.toString() === messageObject.message.StatusFrom)?.title }
          if (messageObject.message.StatusTo) { statusToText = this.$store.getters.getTenderAllStatuses.find(i => i.statusCode.toString() === messageObject.message.StatusTo)?.title }
          result += `<div ${secondLineStule}>${this.$t('Notifications.NotificationType.ChangeTenderStatus')} з <b>${statusFromText || '-'}</b> на <b>${statusToText || '-'}</b></div>`
          break
        case 'UnselectTenderBid':
          result += `<div ${secondLineStule}>${this.$t('Notifications.NotificationType.UnselectTenderBid')} протягом 30 днів</div>`
          break
        case 'CancelTenderBid':
          result += `<div ${secondLineStule}>${this.$t('Notifications.NotificationType.CancelTenderBid')} ${messageObject.message.Author}</div>`
          break
        case 'ProlongateTender':
          result += `<div ${secondLineStule}>Продовжено до ${this.$d(new Date(messageObject.message.ProlongationTo), 'shortDate')}, ${this.$d(new Date(messageObject.message.ProlongationTo), 'time')}</div>`  //TODO: исправить на нормальную дату
          break
        case 'ChangeTenderWinner':
          result += `<div>${this.$t('Notifications.NotificationType.ChangeTenderWinner')}</div>`
          break
        case 'AwatingTenderConfirmation':
          result += `<div ${secondLineStule}>${this.$t('Notifications.NotificationType.AwatingTenderConfirmation')}</div>`
          break
        case 'ChangeTenderApprovalStatus':
          result += `<div ${secondLineStule}>${messageObject.message.Author} - Погоджено</div>` //TODO: Когда узнаем что за свойства, поправим
          break
        case 'AgreementAssigned':
          result += result += `<div ${secondLineStule}>${this.$t('Common.YouHaveSddedToApprover')}</div>`
          break
        default:
          result += `<div ${secondLineStule}>${this.$t('Notifications.NotificationType.' + messageObject.message.messageType)} ${this.$t('Purchasing.From')} ${messageObject.message.Author}</div>`
        }

        resolve(result)
      })
    },
  }
}
